/**
 *
 * Asynchronously loads the component for Media
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Media = lazyLoad(() => import('./index'));
